class CustomMutirows extends HTMLElement {
  constructor() {
    super();
    this.initPages();
  }
  initPages() {
    if (window.innerWidth < 989) {
      var rowSplide = new Splide(this.querySelector('.splide'), {
        type: 'loop',
        perPage: 1,
        perMove: 1
      });
  
      rowSplide.mount();
    }
   
  }
}

customElements.define('custom-mutirows', CustomMutirows);